/**
 * Grenzen der Bildschirmgrößen (DESIGN `spacing.bp-tablet`, `spacing.bp-desktop`; wie `--breakpoint-*` in styles.css):
 * unter `BP_TABLET` Handy, ab `BP_DESKTOP` Desktop. Gemeinsam für App (`useScreen`) und Oberflächen-Tests.
 */
export const BP_TABLET = 768;
export const BP_DESKTOP = 1280;
